import PropTypes from 'prop-types';

import {
  CONTRIBUTOR_PERMISSION_CHECK_TYPE,
  PERMISSION_TYPES,
} from '../../../../../constants/contributors';
import useContributorPermission from '../hooks/useContributorPermission';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  contributorPermissionProps: PropTypes.shape({
    checkType: PropTypes.oneOf(
      Object.values(CONTRIBUTOR_PERMISSION_CHECK_TYPE),
    ),
    entityId: PropTypes.string,
    permissions: PropTypes.arrayOf(
      PropTypes.shape({
        permission: PropTypes.string,
        type: PropTypes.oneOf(Object.values(PERMISSION_TYPES)),
      }),
    ),
  }),
  fallbackContent: PropTypes.any,
};

const ContributorFeatureBlock = ({
  children,
  contributorPermissionProps,
  fallbackContent,
}) => {
  const permissionItem = useContributorPermission(
    contributorPermissionProps || {},
  );

  if (permissionItem.isAllowed) {
    return typeof children === 'function'
      ? children(permissionItem)
      : children ?? null;
  }

  return typeof fallbackContent === 'function'
    ? fallbackContent(permissionItem)
    : fallbackContent ?? null;
};

ContributorFeatureBlock.propTypes = propTypes;

export default ContributorFeatureBlock;
